<template>
	<div>
		<MedicationFormTable />
	</div>
</template>
  
<script>
/**
 * This file shows all currently stored medication forms and allows adding, editing, viewing and soft deleting these.
 */
import MedicationFormTable from "@/components/medication/medication_form/MedicationFormTable";
export default {
	name: "MedicationForm",
	components: { MedicationFormTable },
	data() {
		return {};
	},
	computed: {},
	mounted() { },
	methods: {},
};
</script>
  
<style lang="scss" scoped></style>
  